import {TomSelectController} from "@finchi/tom-select-coreui"

// Multi selects keep the placeholder visible next to selected items
// (Tom Select hidePlaceholder defaults to false in multi mode).
export class TomSelectMultiController extends TomSelectController {
	get tomSelectOptions() {
		return {...super.tomSelectOptions, hidePlaceholder: true}
	}
}
